import { createReducer, on } from '@ngrx/store';
import { UserInfo } from 'src/services/auth.service';
import { updateUserInfo } from '../actions/user-info.action';

export type UserInfoState = UserInfo;

export const initialState = null as UserInfoState | null;

export const userInfoReducer = createReducer(
    initialState,
    on(updateUserInfo, (_, { userInfo }) => userInfo)
);
